(function($) {

$(document).ready(function(){
	if ($('.hv-gallery').length) {
		var left = false;
		// clicking an image in a gallery thumb section
		$('.hv-gallery__thumbs__inner > div').on('click',function(){
			var gallery = $(this).closest('.hv-gallery');
			var image 	= $(this).attr('full');
			var imgHTML = 
			$(this).addClass("active").siblings().removeClass('active');
			// gallery animation
			if (gallery.find('.hv-gallery__image__inner').length) { // there's already an image in the gallery
				if (left) {
					left = false;
					gallery.find('.hv-gallery__image__inner').animate({left:'-50px',opacity:0},500,function(){
						gallery.find('.hv-gallery__image').html('<div class="hv-gallery__image__inner" style="opacity:0;left:50px;background-image:url('+image+')"><img src="'+image+'"></div>');
						gallery.find('.hv-gallery__image__inner').animate({left:0,opacity:1},500);	
					});
				} else {
					gallery.find('.hv-gallery__image__inner').animate({left:'50px',opacity:0},500,function(){
						gallery.find('.hv-gallery__image').html('<div class="hv-gallery__image__inner" style="opacity:0;left:-50px;background-image:url('+image+')"><img src="'+image+'"></div>');
						gallery.find('.hv-gallery__image__inner').animate({left:0,opacity:1},500);	
					});
				}
			} else {
				gallery.find('.hv-gallery__image').html('<div class="hv-gallery__image__inner" style="opacity:0;left:-50px;background-image:url('+image+')"><img src="'+image+'"></div>');
				gallery.find('.hv-gallery__image__inner').animate({left:0,opacity:1},500);
			}
			// move the thumbs to the correct position			
			var thumbs 			= gallery.find('.hv-gallery__thumbs__inner > div')
			var currentIndex 	= thumbs.index($('div.active'));
			var maxIndex 		= thumbs.length-1;
			var maxWidth 		= gallery.find('.hv-gallery__thumbs__inner').outerWidth();
			var thumbsInView 	= Math.floor(maxWidth / 75);
			var halfThumbs		= thumbsInView/2;
			
			console.log('thumbs in view: '+thumbsInView+'. max width: '+maxWidth);

			if (maxIndex > thumbsInView) {
				if (currentIndex + halfThumbs < maxIndex) { // check if current index is not in upper range
					if (currentIndex > halfThumbs) { // check if current index is more than the middle area
						var leftOffset = $(this).position().left;
						gallery.find('.hv-gallery__thumbs__inner').css('left',-leftOffset+((halfThumbs) * 75));
					} else {
						gallery.find('.hv-gallery__thumbs__inner').css('left',0);
					}
				} else {
					// set leftOffset to max in case reversing gallery direction
					var leftOffset = (thumbs.length * 75) - maxWidth;
					gallery.find('.hv-gallery__thumbs__inner').css('left',-leftOffset);
				}
			}
		});
		// clicking on left gallery arrow
		$('.hv-gallery__controls .prev').on('click',function(){
			var gallery 		= $(this).closest('.hv-gallery');
			var thumbs 			= gallery.find('.hv-gallery__thumbs__inner > div')
			var currentIndex 	= thumbs.index($('div.active'));
			var maxIndex 		= thumbs.length-1;
			if (currentIndex-1 <= -1) {
				currentIndex = maxIndex;
			} else {
				currentIndex--;
			}
			left = true;
			thumbs.eq(currentIndex).trigger('click');
		});
		// clicking on right gallery arrow
		$('.hv-gallery__controls .next').on('click',function(){
			var gallery 		= $(this).closest('.hv-gallery');
			var thumbs 			= gallery.find('.hv-gallery__thumbs__inner > div')
			var currentIndex 	= thumbs.index($('div.active'));
			var maxIndex 		= thumbs.length-1;
			if (currentIndex+1 > maxIndex) {
				currentIndex = 0;
			} else {
				currentIndex++;
			}
			thumbs.eq(currentIndex).trigger('click');
		});
		// keyboard controls	
		$(document).on('keyup',function(e){
			if (e.which==39) { //right
				$('.hv-gallery__controls .next').trigger('click');
			}
			if (e.which==37) { //left
				$('.hv-gallery__controls .prev').trigger('click');
			}
		});
		// swipe controls
		var mX = 0;
		var drag = false;
		var nextIndex;
		var delta;
		var diff;

		$('.hv-gallery__image').on('mousedown touchstart', function(e) {
			drag = true;
			if (e.type == 'mousedown') {
				mX = e.pageX;
			}
			if (e.type == 'touchstart') {
				mX = e.originalEvent.touches[0].pageX;
			}
			e.preventDefault();
			e.stopPropagation();
		});

		$('.hv-gallery__image').on('mousemove touchmove', function(e) {
			var gallery 		= $(this).closest('.hv-gallery');
			var galleryItems	= gallery.find('.hv-gallery__thumbs__inner > div');
			var currentItem 	= galleryItems.filter('.active');			
			var currentIndex 	= galleryItems.index(currentItem);
			var maxIndex 		= galleryItems.length - 1;

			if (drag == true) {
				var direction, eX;
				if (e.type == 'mousemove') eX = e.pageX;
				if (e.type == 'touchmove') eX = e.originalEvent.touches[0].pageX;

				if (mX != eX) {
					if (mX < eX) {
						console.log('dragging right');
					} else {
						console.log('dragging left');
					}

					diff = mX - eX;
					delta = diff > 0 ? 1 : -1;

					nextIndex = currentIndex + delta;
					if (nextIndex > maxIndex) nextIndex = 0;
					if (nextIndex < 0) nextIndex = maxIndex;
				}
				mX = eX;
				e.preventDefault();
				e.stopPropagation();
			}
		});

		$('.hv-gallery__image').on('mouseup touchend', function(e) {
			if (drag && delta !== undefined) {
				var gallery = $(this).closest('.hv-gallery');
				if (diff > 5) {
					$('.hv-gallery__controls .next').trigger('click');
				}
				if (diff < -5) {	
					$('.hv-gallery__controls .prev').trigger('click');													
				}
				e.preventDefault();
				e.stopPropagation();
				drag = false;
				delta = undefined;
				diff = null;
			}
		});
	}
});

})( jQuery );  